enum itemMenuOptions {
    copyLink = 'Copy Link',
    clone = 'Clone',
    edit = 'Edit',
    addToProject = 'Add to Project',
}

export {itemMenuOptions};